import { Icon } from '@chakra-ui/react';

export const ReplayIcon = (props: any) => (
  <Icon aria-label="replay icon" viewBox="0 0 16 16" {...props}>
    <path
      d="m8 3.33333333v-2.66666666l-3.33333333 3.33333333 3.33333333 3.33333333v-2.66666666c2.2066667 0 4 1.79333333 4 4 0 2.20666663-1.7933333 4.00000003-4 4.00000003-2.20666667 0-4-1.7933334-4-4.00000003h-1.33333333c0 2.94666663 2.38666666 5.33333333 5.33333333 5.33333333 2.9466667 0 5.3333333-2.3866667 5.3333333-5.33333333 0-2.94666667-2.3866666-5.33333334-5.3333333-5.33333334z"
      fill="currentColor"
    />
  </Icon>
);
